import { render, staticRenderFns } from "./turnOver.vue?vue&type=template&id=e46684fa&scoped=true"
import script from "./turnOver.vue?vue&type=script&lang=js"
export * from "./turnOver.vue?vue&type=script&lang=js"
import style0 from "./turnOver.vue?vue&type=style&index=0&id=e46684fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46684fa",
  null
  
)

export default component.exports